import ScorePreviewLine from './ScorePreviewLine';

function ScorePreview(props) {
    const {score} = props;
    const {attempt, word, attempts} = score;
    const wordLines = attempts.map((currentAttempt, index) => {
      return (
        <ScorePreviewLine currentAttempt={currentAttempt} word={word} key={index} index={index} attempt={attempt}/>
      );
    });
    
    return (
        <div class="score-preview">
            {wordLines}
        </div>
    );
}

export default ScorePreview;